<template>
  <div class="contentRightMenu">
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">学术订阅</span>
      </div>
    </div>
    <div class="marginBottom20 marginTop20">添加订阅标签<span class="normalColor">（最多添加5个）</span> </div>
    <div class="fileBlock display_center"
         @click="showInput">
      <img src="/image/geren/jiahao.png">
    </div>
    <div class="marginTop20 marginBottom20">
      <span>已添加标签：</span>
      <a :key="tag"
         v-for="tag in addSubsribe.lablename"
         class="gl_pad_square_btn marginRight10 gl_pad_btn_square_active">
        <img src="/image/geren/smallclsoe.png"
             style="    width: 10px;    height: 10px;"
             class="close"
             @click="handleClose(tag)">
        {{tag}}
      </a>
    </div>
    <div class="border_bottom_18"></div>
    <div class="fontsize16 marginBottom20 marginTop20">
      推送频率
    </div>
    <div>
      <label for="zhou"
             class="marginRight40">
        <el-radio v-model="addSubsribe.frequency"
                  label="2">每周</el-radio>
        <!-- <input type="radio" name="sel" v-model="addSubsribe.frequency"  id="zhou" value="0" />每周 -->
      </label>
      <label for="nian">
        <el-radio v-model="addSubsribe.frequency"
                  label="1">每月</el-radio>
        <!-- <input type="radio" name="sel" v-model="addSubsribe.frequency" id="nian" value="1" />每年 -->
      </label>
    </div>
    <!-- <div class="display_center_ud marginTop20">
      <div>
        邮箱地址：
      </div>
    </div> -->
    <div class="display_center_ud marginTop20">
      <div>
        您的邮箱地址：
      </div>
      <div>
        <el-input size="small"
                  class="input"
                  v-model="addSubsribe.pushemail"
                  placeholder="请填写正确的邮箱地址"></el-input>
      </div>
    </div>
    <div v-if="this.$route.query.type == 'edit'"
         class="marginTop40">

      <router-link @click.native="SaveSubscription(1)"
                   to=""
                   class="cancelbtn marginRight20">修改完成</router-link>
      <router-link :to="{name:'userSubscribeMenu'}"
                   class="cancelbtn">返回</router-link>
    </div>

    <div v-else
         class="text_center marginTop50">

      <router-link @click.native="SaveSubscription(1)"
                   to=""
                   class="confirmBtn">完成订阅</router-link>
    </div>
    <el-dialog title="选择标签"
               center
               :visible.sync="dialogFormVisible"
               :modal-append-to-body='false'
               custom-class="success_model">
      <div>
        <el-tree :data="setTree"
                 node-key="id"
                 :default-expanded-keys="[key]"
                 @node-click="handleNodeClick"></el-tree>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import validate from "../../assets/unit/validate";
export default {
  name: "userSubscribeOpera",
  data () {
    return {
      AuthorId: '',
      userName: '',
      dialogFormVisible: false,//标签弹出框
      key: 1,
      setTree: [],
      addSubsribe: {
        frequency: "2", //频率
        lablename: [],
        pushemail: "",
        id: 0,
        isFirstSubscript: 0,
        userid: 0, //用户ID
        username: '',
        status: 0
      },
      apiData: "",
      // 推送频率
      sel: "",
      // 邮箱
      emailValue: ""
    }
  },
  methods: {
    handleClose (tag) {

      this.addSubsribe.lablename.splice(this.addSubsribe.lablename.indexOf(tag), 1);
    },
    //标签按钮的选择
    showInput () {
      this.dialogFormVisible = true;
      this.getTreeListData();
    },
    //绑定树
    getTreeListData () {
      let _this = this;
      _this.httphelper.get('/api/CGPInfoApi/GetGpLabelInfo').then(res => {
        if (res.code == 1 && res.data != null) {
          let array = JSON.parse(JSON.stringify(res.data).replace(/colId/g, "id").replace(/name/g, "label")
            .replace(/pId/g, "parentId").replace(/queryCoursesInfoList/g, "children"))
          _this.setTree = array;
        }
      });
    },
    //标签选中事件
    handleNodeClick (data) {
      this.dialogFormVisible = false;
      if (this.addSubsribe.lablename.length > 4) {
        this.$message({
          message: "只能选择5个人标签",
          center: true,
          type: 'error'
        })
      } else {
        if (this.addSubsribe.lablename.indexOf(data.label) < 0) {
          this.addSubsribe.lablename.push(data.label);
        } else {
          this.$message({
            message: "重复选择标签",
            center: true,
            type: 'error'
          })
        }
      }
    },
    //完成订阅
    SaveSubscription (status) {
      if (status == 2) {
        this.$confirm('是否取消订阅?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.SaveSub(status);
        })
      } else {
        this.SaveSub(status);
      }
    },
    //保存，修改订阅
    SaveSub (status) {
      let _this = this
      if (_this.addSubsribe.lablename.length < 1) {
        _this.$message({
          message: "请选择订阅标签",
          center: true,
          type: 'error'
        });
        return false;
      }
      if (_this.addSubsribe.pushemail == null && _this.addSubsribe.pushemail == '') {
        _this.$message({
          message: "请输入邮箱地址",
          center: true,
          type: 'error'
        });
        return false;
      } else {

        if (!validate.validateEmail(_this.addSubsribe.pushemail)) {
          _this.$message({
            message: "请输入合法的邮箱",
            center: true,
            type: 'error'
          });
          return false;
        }

        _this.httphelper.post('/api/SubscriptionApi/SaveSubscriptionInfo', {
          "id": _this.addSubsribe.id,
          "lablename": _this.addSubsribe.lablename.join(','),
          "frequency": parseInt(_this.addSubsribe.frequency),
          "pushemail": _this.addSubsribe.pushemail,
          "isFirstSubscript": 1,
          "userid": Number(_this.AuthorId),
          "username": this.userName,
          "status": status
        }).then(res => {
          if (res.data.code == 200) {
            _this.$message({
              message: res.data.msg,
              center: true,
              type: 'success'
            })
            //订阅成功，跳转信息列表
            _this.$router.push({
              path: 'userSubscribeMenu'
            });
          } else {
            _this.$message({
              message: res.data.msg,
              center: true,
              type: 'error'
            })
          }
        });
      }

    },
    //查询订阅信息
    GetSubscriptionInfoList () {
      let _this = this
      _this.httphelper.post('/api/SubscriptionApi/GetSubscriptionInfoList', {
        "id": 0,
        "lablename": "",
        "frequency": 0,
        "pushemail": "",
        "isFirstSubscript": 0,
        "userid": Number(this.AuthorId), //用户ID
        "username": "",
        "status": 0
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data
          if (data != null && data.id > 0) {
            //给页面赋值
            _this.addSubsribe = data;
            _this.addSubsribe.lablename = data.lablename.split(',');
            _this.addSubsribe.frequency = data.frequency.toString();
          }
        }
      });
    },
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.userSubscribeOpera
      })
    }
  },
  created () {
    //获取用户信息
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
      this.userName = JSON.parse(localStorage.getItem("ResData")).nickname;
    }
    //1.先根据用户id查询，是否第一次订阅,否则直接赋值
    this.GetSubscriptionInfoList();
    // this.getData()
  },
}
</script>

<style scoped>
.fileBlock {
    width: 108px;
    height: 108px;
    background: #def3f3;
    border: 1px solid #0b8586;
    cursor: pointer;
}
.input {
    width: 455px;
    height: 35px;
    box-sizing: border-box;
}
.confirmBtn {
    width: 150px;
    height: 40px;
    background: #0b8586;
    border-radius: 20px;
    display: inline-block;
    text-align: center;
    line-height: 40px;
    color: #fff;
}

.modifybtn {
    display: inline-block;
    width: 150px;
    height: 40px;
    background: #eff1f4;
    border-radius: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    text-align: center;
}
.cancelbtn {
    display: inline-block;
    width: 150px;
    height: 40px;
    background: #0b8586;
    border-radius: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
    text-align: center;
}
</style>
